import { Component, OnInit, HostListener } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CommonHttpService } from "../commonHttp.service";
import { LoaderService } from "../../_shared/services/loader.service";
import "rxjs/add/operator/map";
import "rxjs/add/operator/first";

@Component({
  selector: "app-orders",
  templateUrl: "./orders.component.html",
  styleUrls: ["./orders.component.css"],
})
export class OrdersComponent implements OnInit {
  constructor(
    private service: CommonHttpService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) { }
  baseUrl: any = environment.apiUrl;
  orders: any = [];
  customerId: any;
  orderStatus: any = 0;
  orderNo: any;
  isavailable = false;
  utm_source: string;

  ngOnInit() {
    // this.route.queryParams
    //   .filter((params) => params.utm_source)
    //   .subscribe((params) => {
    //     console.log(params); // {order: "popular"}
    //     console.log(params.utm_source);
    //     if (params.utm_source != undefined) {
    //       this.isavailable = true;
    //phonepe://checkoutResolve?reservationId=R2006281933289324358118&redirectUrl=https://nowgroceryecommerce.ajatus.in/orderdetail/10624
    //     }
    //     this.utm_source = params.utm_source;
    //   });
    console.log(this.isavailable);
    this.customerId = localStorage.getItem("customerId");
    setTimeout(() => {
      this.loadData();
    }, 1);
  }

  loadData() {
    this.loaderService.display(true);

    this.service
      .get(
        this.baseUrl + "EOrderAPI/GetAllOrderByCustomerId/" + this.customerId
      )
      .subscribe(
        (data) => {
          console.log(data);
          this.orders = data;
          this.loaderService.display(false);
        },
        (error) => {
          this.loaderService.display(false);
        }
      );
  }

  search() {
    console.log(this.orderNo);
    if (!this.orderNo) {
      this.loadData();
    } else {
      this.loaderService.display(true);
      this.service
        .get(this.baseUrl + "EOrderAPI/GetOrderByOrderNo/" + this.orderNo)
        .subscribe(
          (data) => {
            console.log(data);
            this.orders = data;
            this.loaderService.display(false);
          },
          (error) => {
            this.loaderService.display(false);
          }
        );
    }
  }

  filterOrders() {
    console.log(this.orderStatus);
    if (this.orderStatus == 0) {
      this.loadData();
    } else {
      this.loaderService.display(true);
      this.service
        .get(
          this.baseUrl +
          "EOrderAPI/GetOrderByOrderStatusId/" +
          this.orderStatus +
          "?customerId=" +
          this.customerId
        )
        .subscribe(
          (data) => {
            console.log(data);
            this.orders = data;
            this.loaderService.display(false);
          },
          (error) => {
            this.loaderService.display(false);
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/orders/orders.component.ts